import { Button, MenuItem, TextField } from "@material-ui/core";
import { useEffect, useState } from "react";
import { useParams } from "react-router";
import ListItemIcon from "@material-ui/core/ListItemIcon";
import ListItemText from "@material-ui/core/ListItemText";
import Checkbox from "@material-ui/core/Checkbox";
import Select from "@material-ui/core/Select";
import InputLabel from "@material-ui/core/InputLabel";
import ErrorMessage from "../../components/ErrorMessage/ErrorMessage";
import SuccessMessage from "../../components/SuccessMessage/SuccessMessage";
import { useGetSections } from "../../hooks/useGetSections";
import { useGetQuiz } from "../../hooks/useGetQuiz";
import axios from "axios";
import Questions from "../../components/CreateQuestions/Questions"
import "./QuizUpdate.css";
import { useGetUser } from "../../hooks/useGetUser";

const QuizUpdate = () => {
  let [quiz, setQuiz] = useState();
  const [password, setPassword] = useState("");
  const [name, setName] = useState("");
  const [error, setError] = useState(false);
  const [success, setSuccess] = useState(false);
  const [errorMsg, setErrorMsg] = useState("");
  const [sections, setSections] = useState();
  const [timeLimit, setTimeLimit] = useState();
  const [selectedSections, setSelectedSections] = useState([]);
  const [selectedSectionsID, setSelectedSectionsID] = useState([]);
  const { sectionData } = useGetSections();
  const { user } = useGetUser();
  const { id } = useParams();  
  quiz = useGetQuiz(id).quiz;


  const handleSubmit = async () => {
    try {
        const req = {};
        if (name) req.quiz_name = name;
        if (password) req.password = password;
        if (timeLimit) req.time_limit = timeLimit;
        if (selectedSectionsID.length) req.year_section = selectedSectionsID;
        const { data } = await axios.patch(`https://computer-quiz-backend.herokuapp.com/quizzes/${id}`, {
          quiz: req
        },
        {
          headers: { 'api-token': localStorage.getItem('token') }
        }
        );
        setQuiz(data);
        setSuccess(true);
      } catch (error) {
        setError(true);
        setErrorMsg(JSON.stringify(error?.response?.data));
      }
  };

  localStorage.setItem('user', user);

  useEffect(() => {
    setSections(sectionData);
  }, [sectionData]);

  useEffect(() => {
    if (quiz) setSelectedSectionsID(quiz.year_section);
  }, [quiz]);

  const handleSelectedSections = event => {
    const value = event.target.value;
    const texts = [];
    for (const section of sections) {
      for (const val of value) {
        if (section._id === val) texts.push(section.year_section)
      }
    }
    setSelectedSections(texts);
    setSelectedSectionsID(value);
  };

  const handleRender = () => {
    selectedSections.map(section => {
      for (const section of sections) {
        if (section._id === section) return section.year_section;
      }
      return section;
    });
    return selectedSections.join(', ');
  };

  const displaySuccess = () => {
    const msg =  (<SuccessMessage>Quiz updated!</SuccessMessage>)
    setTimeout(() => {
        setSuccess(false);
      }, 3000);
    return msg;
  };


  return (
    <div className="content">
      <div className="settings">
        <span style={{ fontSize: 30 }}>Quiz Settings</span>
        <div className="set_select">
          { error && <ErrorMessage>{errorMsg}</ErrorMessage> }
          { success && displaySuccess() }
          { quiz && 
            <TextField
                style={{ marginBottom: 20 }}
                label="Quiz Name"
                defaultValue={quiz.quiz_name}
                variant="outlined"
                onChange={(e) => setName(e?.target?.value)}
            />
            }
          { quiz &&
          <TextField
            style={{ marginBottom: 20 }}
            label="Quiz Password"
            defaultValue={quiz.password}
            variant="outlined"
            type="password"
            onChange={(e) => setPassword(e?.target?.value)}
          />
          }
          <InputLabel style={{ paddingLeft: 12 }} id="mutiple-select-label">Sections</InputLabel>
          { quiz && sections &&
            <Select
              multiple
              label="Sections"
              labelId="mutiple-select-label"
              value={selectedSectionsID}
              name="selectedSections"
              id="selectedSections"
              variant="outlined"
              style={{ marginBottom: 20 }}
              onChange={handleSelectedSections}
              renderValue={handleRender}
            >
              {sections.map((cat) => (
                <MenuItem key={cat.year_section} value={cat._id}>
                  <ListItemIcon>
                    <Checkbox checked={selectedSectionsID.indexOf(cat._id) > -1} />
                  </ListItemIcon>
                  {/* {cat.year_section} */}
                  <ListItemText primary={cat.year_section} />
                </MenuItem>
              ))}
            </Select>
          }
          { quiz &&
            <TextField
                style={{ marginBottom: 20 }}
                label="Time Limit In Seconds (ex: 300 for 5 mins)"
                defaultValue={quiz.time_limit}
                variant="outlined"
                type="number"
                onChange={(e) => setTimeLimit(e?.target?.value)}
            />
          }
          <Button
            variant="contained"
            color="primary"
            size="large"
            onClick={handleSubmit}
          >
            Update Quiz Settings
          </Button>
        </div>
      </div>
      {
        quiz && 
        <div className="banner">
          <Questions
            quiz={quiz}/>
        </div>
      }
    </div>
  );
};

export default QuizUpdate;
